//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

import { createRoot } from "react-dom/client";
import * as fonts from "~irad/Styling/SoPFonts";
import * as textCodeService from "~base/Services/TextCodeService";
import MainApp from "./MainApp";

textCodeService.initialize(["nl-NL"], ["VisiFinance.*", "SoP.*", "SoPNL.*"]);
fonts.attachCss();

createRoot(document.getElementById("react-main-root")!).render(<MainApp />);
